var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "code",
                      label: _vm.$t("Código"),
                      placeholder: _vm.$t("Código"),
                    },
                    model: {
                      value: _vm.filter.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "code", $$v)
                      },
                      expression: "filter.code",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "description",
                      label: _vm.$t("Descrição"),
                      placeholder: _vm.$t("Descrição"),
                    },
                    model: {
                      value: _vm.filter.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "description", $$v)
                      },
                      expression: "filter.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "movement_type",
                      type: "vue-select",
                      options: _vm.allMovementTypeOptions(),
                      label: _vm.$t("Tipo de movimento"),
                      placeholder: _vm.$t("Selecione"),
                    },
                    model: {
                      value: _vm.filter.movementType,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "movementType", $$v)
                      },
                      expression: "filter.movementType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "cfop_type",
                      options: _vm.cfopTypeOptions(),
                      type: "vue-select",
                      label: _vm.$t("Tipo de CFOP"),
                      placeholder: _vm.$t("Selecione"),
                    },
                    model: {
                      value: _vm.filter.cfopType,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "cfopType", $$v)
                      },
                      expression: "filter.cfopType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "active",
                      name: "active",
                      label: _vm.$t("Status"),
                      placeholder: _vm.$t("Todos"),
                      type: "vue-select",
                      options: _vm.activeInactiveTypes(),
                    },
                    model: {
                      value: _vm.filter.active,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "active", $$v)
                      },
                      expression: "filter.active",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "cfops-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(_vm.$tc("CFOP.NAME")),
              fields: _vm.fields,
              items: _vm.cfops,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(active)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.active, type: "yesNo" },
                    }),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "is-active": row.item.active,
                        "show-update": _vm.$can("Update", "Cfop"),
                        "show-delete": false,
                        "show-activate": _vm.$can("Activate", "Cfop"),
                        "show-deactivate": _vm.$can("Deactivate", "Cfop"),
                      },
                      on: {
                        update: function ($event) {
                          return _vm.updateCfop(row)
                        },
                        activate: function ($event) {
                          return _vm.activateOrDeactivateCfop(row)
                        },
                        deactivate: function ($event) {
                          return _vm.activateOrDeactivateCfop(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "cfops-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("fab", {
        attrs: { "main-tooltip": _vm.$t("Adicionar CFOP") },
        on: { click: _vm.create },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }